import { render, staticRenderFns } from "./GameFacesDebug.vue?vue&type=template&id=15096cc2&scoped=true&"
import script from "./GameFacesDebug.vue?vue&type=script&lang=js&"
export * from "./GameFacesDebug.vue?vue&type=script&lang=js&"
import style0 from "./GameFacesDebug.vue?vue&type=style&index=0&id=15096cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15096cc2",
  null
  
)

export default component.exports